import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/pages/Agence";

export default function MetierLayout({ overline, title, intro, image, sections, testid, cta }) {
  return (
    <div data-testid={testid}>
      <PageHero overline={overline} title={title} subtitle={intro} />

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-12 gap-16">
            <div className="lg:col-span-5">
              <img src={image} alt={title} className="w-full aspect-[3/4] object-cover sticky top-24" />
            </div>
            <div className="lg:col-span-7 space-y-14">
              {sections.map((s, i) => (
                <div key={s.heading}>
                  <span className="font-overline text-[#B8935A]">0{i + 1}</span>
                  <h2 className="font-serif text-3xl lg:text-4xl text-[#0F172A] mt-3 leading-tight">
                    {s.heading}
                  </h2>
                  <div className="text-[#475569] mt-5 leading-relaxed space-y-3 text-[1.02rem]">
                    {s.body.map((p, idx) => (
                      <p key={idx}>{p}</p>
                    ))}
                  </div>
                  {s.list && (
                    <ul className="mt-5 space-y-2.5">
                      {s.list.map((item) => (
                        <li key={item} className="flex gap-3 text-[#1E293B]">
                          <span className="text-[#B8935A] mt-1">—</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  {s.extra}
                </div>
              ))}

              {cta && (
                <div className="border-t border-[#E2E8F0] pt-10 mt-12">
                  <h3 className="font-serif text-2xl text-[#0F172A]">{cta.title}</h3>
                  <p className="text-[#64748B] mt-3">{cta.text}</p>
                  <Link
                    to={cta.href}
                    data-testid={`${testid}-cta`}
                    className="gpi-btn-primary mt-6"
                  >
                    {cta.label}
                    <ArrowUpRight size={14} />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
